import * as React from "react";
import { MainLayout } from "../../components/Layout";
import Headline from "../../components/Headline";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";
import "./styles.scss";
import { oneLink } from "../../shared/oneLink";
import AnchorButton from "../../components/AnchorButton";

const PaymentMakeFinish = () => {
    return (
        <MainLayout>
            <Headline>有料プラン購入完了</Headline>
            <section className="payment-make-finish">
                <p className="finish-message">
                    パートナーエージェントAppの有料会員プラン購入が完了しました！
                    <br />
                    アプリを開いて引き続きサービスをご利用ください。
                </p>

                <div className="user-action">
                    <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
                    <LinkButton color="secondary" to={URL_PATHS.myPage()}>
                        マイページへ
                    </LinkButton>
                </div>
            </section>
        </MainLayout>
    );
};

export default PaymentMakeFinish;
